import React, { useState, useEffect } from "react";
import axios from 'axios';
import Loader from "../../../components/loader";
import { subMonths, format, isAfter, isBefore } from 'date-fns';
import startCase from 'lodash/startCase';
import './style.scss';
import { upperCase } from "lodash";
import ToastMessage from '../../../components/toast';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import ReportDateRange from "../../../components/reportDateRange";

const ManagementOverview = props => {

    const [loading, setLoading] = useState();
    const [report, reportState] = useState({});
    const [startDate, setStartDate] = useState(subMonths(new Date(), 2));
    const [endDate, setEndDate] = useState(new Date());
    const [searchText, searchInputText] = useState("");


    async function getReport(startDate, endDate) {
        let startDateModify = new Date(startDate);
        let endDateModify = new Date(endDate);
        var correctDate = isBefore(startDateModify, endDateModify)
        if (correctDate) {
            setLoading(true);
            let mangeOverView = {};
            let MOReport = await axios.get('api/management-overview/report', {
                params: {
                    startDate: format(new Date(startDate), "MM/dd/yyyy"),
                    endDate: format(new Date(endDate), "MM/dd/yyyy"),
                }
            }).catch(e => e);

            let data = MOReport?.data || {};
            Object.keys(data).map(key => {
                let dispKey = startCase(key);
                let caps = ["Tlm", "Hr", "Pr"];
                if (dispKey.includes(" ")) {
                    dispKey = dispKey.split(" ");
                    if (caps.includes(dispKey[0])) {
                        dispKey[0] = upperCase(dispKey[0]);
                    };
                    dispKey = dispKey.join(" ");
                }
                mangeOverView[dispKey] = data[key]
            })
            reportState(mangeOverView);
            setLoading(false);
        } else {
            let modifyDate = format(new Date(startDate), "MM/dd/yyyy")
            ToastMessage(`Please select date after ${modifyDate}`, "error");
        }

    };

    const searchInput = async (e) => {
        let dataChange = e.target.value
        searchInputText(dataChange)

    }

    useEffect(() => {
        getReport(startDate, endDate)
    }, []);

    return (
        <>

            <div className="table-header d-flex align-items-center justify-content-between">
                <h2 className="page_title">Report</h2>
            </div>

            <div className="shadow_white_box management-overview full-box mt-0">
                <div className=" filter-list d-flex align-items-center justify-content-between mb-5">

                    <div className="filter-field d-flex align-items-center flex-grow-1 me-3">
                        <input
                            type="text"
                            placeholder="Search"
                            autoComplete="off"
                            onChange={searchInput}
                            className="search-input"
                        />
                    </div>

                    <div className="filter-field d-flex align-items-center">
                        <div className="filter-list d-flex align-items-center justify-content-between">
                            <div className="filter_inpt_sec position-relative date-range d-flex">
                                <label className="label">From</label>
                                <ReportDateRange
                                    mode="single"
                                    handleDateRange={(date) => { setStartDate(date) }}
                                    startDate={startDate}
                                />

                            </div>
                            <div className="filter_inpt_sec position-relative date-range d-flex">
                                <label className="label">To</label>
                                <ReportDateRange
                                    mode="single"
                                    handleDateRange={(date) => { setEndDate(date) }}
                                    startDate={endDate}
                                />
                            </div>
                            <div className="df mla">
                                <button
                                    className="ttuc primary report"
                                    onClick={() => getReport(startDate, endDate)}>Run Report</button>
                            </div>

                        </div>
                    </div>
                </div>

                <div className="clients_grid mt-5 ">
                    {loading ? (
                        <div className='loading-data d-flex align-items-center justify-content-center'>
                            <Loader></Loader>
                        </div>
                    ) : (
                        <div
                            className="table_wrpr_management"
                        >
                            {Object.keys(report).filter(key => {
                                let regex = new RegExp(searchText, 'i');
                                return regex.test(key)
                            }).map((key, i) => {
                                //let dispKey = startCase(key);
                                return (
                                    <div className="w75" key={i}>
                                        <div className="w75_inner" key={key} >
                                            <div className="fl">{key}</div>
                                            <div className="fr"> {Array.isArray(report[key]) ?
                                                new Intl.NumberFormat('en-US').format(report[key].length) :
                                                key.includes("Billing") ?
                                                    new Intl.NumberFormat('en-US',
                                                        { style: 'currency', currency: 'USD' }
                                                    ).format(report[key]) :
                                                    new Intl.NumberFormat('en-US').format(report[key])}</div>
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    )}

                </div>

            </div>

        </>

    );
};

export default ManagementOverview;